import { useCallback } from "react";

import { observer } from "mobx-react-lite";

import avatar1 from "../../../../../assets/images/avatar1.png";
import iconRemove from "../../../../../assets/images/exit-full-screen.svg";
import iconMicMute from "../../../../../assets/images/mir-red-mute.svg";
import iconMic from "../../../../../assets/images/mir-red.svg";
import { useAuth } from "../../../../../contexts/authContext";
import { useMeetingDetailsStore } from "../../../../../contexts/meetingDetails/meetingDetailsContext";
import { useApi } from "../../../../../hooks/useApi";

export const ParticipantItem = observer(({ participant }) => {
  const { userData } = useAuth();
  const { meeting } = useMeetingDetailsStore();
  const { uninviteParticipant } = useApi();

  const handleRemoveButtonClick = useCallback(() => {
    uninviteParticipant(meeting.mid, participant.pid)
      .then((res) => console.log(res))
      .catch((e) => console.dir(e));
  }, []);

  return (
    <li key={participant.pid} className="space-between align-items-center">
      <div className="align-items-center">
        <div>
          <img src={participant.avatar || avatar1} width={36} className="m-r-5" alt="" />
        </div>
        <div className="flex-col">
          <span className="bold">
            u{participant.user.uid} {participant.user.first_name} {participant.user.last_name}
          </span>
          <span className="font-10">
            {participant.user.org.name} ({participant.status})
          </span>
        </div>
      </div>
      <div className="flex">
        <img
          src={participant.audio_mute === "unmuted" ? iconMic : iconMicMute}
          width={36}
          className="pointer"
          onClick={() => {
            // handleMicClick(participant, socket)
          }}
          alt=""
        />
        {userData.userId !== participant.user.uid && (
          <div onClick={handleRemoveButtonClick}>
            <img src={iconRemove} width={36} className="m-l-5 pointer" alt="" />
          </div>
        )}
      </div>
    </li>
  );
});
